import { Card, CardContent } from "@volca/ui/components/ui/card";
import { Checkbox } from "@volca/ui/components/ui/checkbox";
import { Label } from "@volca/ui/components/ui/label";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const ReviewConfirmationCard = ({
  confirmed,
  disabled,
  onConfirmedChange,
}: {
  confirmed: boolean;
  disabled: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
}) => (
  <Card className="w-full gap-0 py-0">
    <CardContent className="p-6">
      <Stack className="w-full" gap={4} align="stretch">
        <Stack className="w-full" direction="row" gap={2} align="start">
          <Checkbox
            id="information-confirmed"
            checked={confirmed}
            disabled={disabled}
            onCheckedChange={(checked) => onConfirmedChange(checked === true)}
          />
          <Label htmlFor="information-confirmed">
            I have checked the information and completed it to the best of my
            knowledge.
          </Label>
        </Stack>
        <Text tone="muted">
          Volca will review your information and complete your setup. We will
          contact you if we need more information. You can still read the
          forwarding instructions after you submit.
        </Text>
      </Stack>
    </CardContent>
  </Card>
);
